import moment from 'moment'
import {find, some, filter, isEmpty} from 'lodash'
import {countries} from '@bdswiss/common-enums'


export function validateEmail(email) {
  const pattern =  RegExp("(?!.*\\.$)(?!.*?\\.\\.)^(?!\\.)[^@\\s]+@[^@\\s]+\\.[^@\\s]{2,}$") // eslint-disable-line
  const isValid = pattern.test(email)
  return isValid
}

// Custom regex validator used when signing up as an affiliate
export function validateAffiliateEmail(email) {
  const pattern =  RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/)
  const isValid = pattern.test(email)
  return isValid
}

export function  validatePhone(phone,prefix) {
  const isPhone = (prefix)?RegExp(/^\+\d+$/).test(phone):RegExp(/^\d+$/).test(phone)
  return isPhone
}

export function validateDate(date, format = false, allowContinuously = false) {
  const dateFormats = [
    'YYYY-MM-DD',
    'DD/MM/YYYY',
    'MM/DD/YYYY',
    'DD-MM-YYYY',
    'MM-DD-YYYY',
    'YYYY/MM/DD',
  ]
  allowContinuously && dateFormats.push('DDMMYYYY')
  const valid = format ?  find(dateFormats, (dateFormat) => moment(date, dateFormat, true).isValid()) : some(dateFormats, (dateFormat) => moment(date, dateFormat, true).isValid())
  return  format ? valid : Boolean(valid)
}

export function validateNumber(value) {
  return !isNaN(Number(value))
}

export function validatePersonalIdPayretailers(country, id) {
  let pattern
  if (country === countries.br.key) {
    // eslint-disable-next-line quotes, no-useless-escape
    pattern =  RegExp(/^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/)
  } else if (country === countries.cl.key) {
    // eslint-disable-next-line quotes
    pattern =  RegExp(/^\d{1,2}\.\d{3}\.\d{3}-?[0-9K]$/)
  } else if (country === countries.co.key) {
    // eslint-disable-next-line quotes
    pattern =  RegExp(/^\b([0-9](?:[ .][0-9]{3}){2}(?:[ .][0-9]{3})?|[0-9]{2}(?:[ .][0-9]{3}){1}(?:[ .][0-9]{3})?)\b$/)
  } else if (country === countries.cr.key) {
    // eslint-disable-next-line quotes
    pattern =  RegExp(/^[1-9]\s?\d{4}\s?\d{4}$/)
  } else if (country === countries.pe.key) {
    // eslint-disable-next-line quotes
    pattern =  RegExp(/^\d{8}-?\d{1}$/)
  } else if (country === countries.mx.key) {
    // eslint-disable-next-line quotes
    pattern =  RegExp(/^[A-Z]{4}\d{6}[A-Z]{6}\d{2}$/)
  } else if (country === countries.gt.key) {
    // eslint-disable-next-line quotes
    pattern =  RegExp(/^\d{4}\s?\d{4}\s?\d{1}\s?\d{2}\s?\d{2}$/)
  }


  const isValid = pattern.test(id)
  return isValid
}

export function getMimetype(signature) {
  switch (signature) {
    case '89504E47':
      return 'image/png'
    case '25504446':
      return 'application/pdf'
    case 'FFD8FFDB':
    case 'FFD8FFE0':
    case 'FFD8FFE1':
    case 'FFD8FFEE':
      return 'image/jpeg'
    case '52494646':
      return 'image/jpg'
    case '504B0304':
      return 'application/zip'
    default:
      return 'Unknown filetype'
  }
}

export function checkFileMimeType(file) {
  const blob = file.slice(0, 4)
  return new Promise((resolve, reject) => {
    const filereader = new FileReader()
    filereader.onerror = () => {
      filereader.abort()
      reject(new DOMException('Problem parsing input file.'))
    }
    filereader.onload = function(evt) {
      if (evt.target.readyState === FileReader.DONE) {
        const uint = new Uint8Array(evt.target.result)
        const bytes = []
        uint.forEach((byte) => {
          bytes.push(byte.toString(16))
        })
        const hex = bytes.join('').toUpperCase()
        resolve(getMimetype(hex))
      }
    }
    filereader.readAsArrayBuffer(blob)
  })
}

export function onlyLatinDateCharacters(str) {
  return /^[0-9-]+$/.test(moment(str).format('YYYY-MM-DD'))
}

export function validateDOB(birthday) {
  if (!onlyLatinDateCharacters(birthday)) {
    return false
  }
  const dateFormat = validateDate(birthday, true, true)
  if (dateFormat) {
    const datesDifference = moment.duration(moment().diff(moment(birthday, dateFormat, true).subtract(1, 'days')))
    const age = datesDifference.years()
    const birthdayDay = datesDifference.days()
    return age >= 18 && (age < 120 || (age === 120 && birthdayDay === 0))
  } return false
}

export function validateLength(value, maxLength, minLength, exactLength) {
  if (maxLength) return value.length <= maxLength
  if (minLength) return value.length >= minLength
  if (exactLength) return value.length === exactLength
  return value.length <= maxLength
}

export function validateCharacters(value) {
  if (!value) return true
  else if (value.length < 2) return 'minLengthError'
  else if (/(\s{2,})/gmi.test(value)) return 'consecutiveSpaces'
  else if (/(.)\1{2,}|^(?![A-Za-z]{1})|(?!([A-Za-z\- ]*$))/gmi.test(value)) return 'validationError'
  else return false
}

export function validateCountryCodePrefix(prefix, countryList) {
  const value = prefix.replace(/^\++/, '')
  const allowedPrefixes= filter(countryList, (c) => c.callingCodes ? find(c.callingCodes, (cc) => value.startsWith(cc))
    : value.startsWith(c.callingCode))
  return !isEmpty(allowedPrefixes)
}

export function validateAccountName(value) {
  if (!value) return true
  else if (!(RegExp("^(?! *$)[a-zA-Z0-9-_,.#/! ]{1,}$").test(value))) return 'validationAccountNameError'  // eslint-disable-line
  else return false
}

export const specificProviderValidations = {
  cardpay: {
    street: '^[A-Za-z0-9-\',"./; ]{1,50}$',
    city: '^[A-Za-z0-9-\',. ]{0,50}$',
    zip: '^.{0,12}$'
  }
}

export function validateAddress(address) {
  if (!address) return true
  const checkAddress = RegExp(/^[a-zA-Z0-9 ]*$/g).test(address)
  if (!checkAddress) {
    return 'validationAddressError'
  } else {
    return false
  }
}

export function validatePartnerCode(value, minLength, maxLength) {
  if (!value) {
    return 'requiredField'
  } else if (value.length < minLength) {
    return 'minimumPartnerId'
  } else if (value.length > maxLength) {
    return 'maximumPartnerId'
  } else {
    return ''
  }
}

export function validateOnlyNumbers(value) {
  return !(RegExp(/^[0-9]*$/).test(value))
}

export function validateWebsite(value) {
  return RegExp(/^[A-Za-z0-9-._~:/?#[\]@!$&'()*+;%=]+\.[A-Za-z0-9-._~:/?#[\]@!$&'()*+;%=]+/).test(value)
}

export function validateIsStringContainsEmoji(string) {
  const emojiRegex = /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u
  return emojiRegex.test(string)
}
